/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, Select, MenuItem } from "@mui/material";
import LabelledField from "components/labelled-field/index";
import { isArrayNotEmpty, isFalse, isTrue, isValidOption } from "utils/empty-exists";

const SettingsFormatEdit = (props) => {
    
    const label = props?.label;
    const itemLocalState = props?.itemLocalState;
    const setItemLocalState = props?.setItemLocalState;
    const disabled = props?.disabled;
    const formatOptions = props?.formatOptions;
    const selected = props?.selected;
    const index = props?.index;
    const update = props?.update;
    
    const _format = itemLocalState?.settings?.format;
    const formatValue = isValidOption(_format, formatOptions) ? _format : "field.format.none";
    const { t } = useTranslation();
    
    const onChangeFormat = (event) => {
        // use new value unless none was selected
        const value = event.target.value;
        let updatedValue = (value !== null) ? value : selected;
        // prevent the selection of none
        updatedValue = (updatedValue !== "field.format.none") ? updatedValue : selected;
        const newState = {
            ...itemLocalState,
            value: itemLocalState?.value || "",
            settings: {
                style: itemLocalState?.settings?.style,
                format: updatedValue,
                options: itemLocalState?.settings?.options,
            },
        };
        setItemLocalState(newState);
        update(newState,index);
    };
    
    return (
        <Fragment>
            {isFalse(disabled) &&
                <LabelledField label={label ? label : t("commons.displayAs")} className='labelField'>
                    {isArrayNotEmpty(formatOptions) &&
                        <FormControl sx={{ mt: 1, mb: 1, width: "100%" }} size="small">
                            <Select
                                labelId='demo-select-small-label'
                                id='link-style-select'
                                value={formatValue}
                                fullWidth={true}
                                disabled={disabled}
                                variant='standard'
                                onChange={onChangeFormat}
                            >
                                {/*{formatValue === 'field.format.none' || formatValue === '' &&*/}
                                <MenuItem value='field.format.none'>Select...</MenuItem>
                                {/*}*/}
                                {formatOptions.map((option, index) =>
                                    <MenuItem key={index} value={option?.value}>{option?.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                </LabelledField>
            }
            {/*<p>{formatValue}</p>*/}
            {/*<p>{JSON.stringify(formatOptions, null,2)}</p>*/}
            {isTrue(disabled) &&
                <div
                    style={{
                        width: "100%",
                        height: "64px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#7A7A7A",
                    }}
                >
                    {t("commons.thisContentIsNotForDisplay")}
                </div>
            }
        </Fragment>
    );
};
export { SettingsFormatEdit };
